import React from "react";
import box from "../../icons/Box.png";
import Clock from "../../icons/Clock.png";
import Tool from "../../icons/Tool.png";

const HomeDeliver = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4  pt-5">
          <div className="row">
            <div className="col-lg-2">
              <img src={box} alt="" />
            </div>
            <div className="col-lg-10">
              <h5>Reasonable Prices</h5>
              <p>Quality design at affordable prices</p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4  pt-5">
          <div className="row">
            <div className="col-lg-2">
              <img src={Clock} alt="" />
            </div>
            <div className="col-lg-10">
              <h5>Timely Delivery</h5>
              <p>On-time project completion</p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4  pt-5">
          <div className="row">
            <div className="col-lg-2">
              <img src={Tool} alt="" />
            </div>
            <div className="col-lg-10">
              <h5>Professional Team</h5>
              <p>Expert team,top results</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeDeliver;
